import React, { memo } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { Dialog, DialogContent, DialogTitle, DialogActions } from "@material-ui/core";
import IconClose from "app/common/Icon/IconClose";
import CommonButton from '../Button/CommonButton';
import CloseIcon from '@material-ui/icons/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="right" ref={ref} {...props} />;
});

function FullScreenPopup({
    open,
    handleClose,
    children,
    title,
    fullScreenPicture
}) {
    if (fullScreenPicture)
        return (
            <>
                <Dialog
                    open={open}
                    fullWidth
                    onClose={handleClose}
                    TransitionComponent={Transition}
                    className="popup-container"
                    maxWidth={"xl"}
                    scroll='body'
                >
                    <DialogContent className="contentFullScreen p-0 position-relative">
                        {children}
                        <div className="topImgContainer">
                            <CommonButton
                                className="actionButton"
                                onClick={() => handleClose()}
                            >
                                <CloseIcon className="actionIcon" />
                            </CommonButton>
                        </div>
                    </DialogContent>
                </Dialog >
            </>
        );

    else return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            className="popup-container"
        >
            <DialogTitle className="popup-header flex align-center justify-between">
                {/* {Boolean(title) && ( */}
                <p className="popup-title">{title || ""}</p>
                {/* )} */}
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    className="popup__iconBtn flex align-center justify-right w-unset"
                >
                    <IconClose className="popup__icon" color="#000000" />
                </IconButton>
            </DialogTitle>

            <DialogContent className="contentFullScreen">
                {children}
            </DialogContent>
        </Dialog>
    );
}

export default memo(FullScreenPopup);